module.exports = __webpack_public_path__ + "static/alberta-college-of-paramedics-logo-eae1d5cb6bb5166997795b954d5ea956.png";